import { withCarTypes } from '@ati/hocs';
import OptionsSelector from '@components/options-selector';
import { observer } from 'mobx-react-lite';

import { MobileScreen } from 'components/MobileScreen';
import { useStore } from 'hooks/useStore';

import css from './Mobile.module.css';

const WrappedOptionsSelector = withCarTypes(OptionsSelector);

const Mobile = () => {
  const {
    dictionaries,
    dictionaries: { data },
    app: { i18n },
    filter: {
      truckType: { setTruckTypesFromBitSum, truckTypes, clearTruckTypes, isDefault, addParentCarTypes },
    },
  } = useStore();

  const actions = {
    second: {
      onClick: clearTruckTypes,
      text: i18n.common.reset,
    },
  };

  const handleChange = (_values: string[], bitsum: string) => {
    setTruckTypesFromBitSum(bitsum);
  };

  const selectedValues = addParentCarTypes(dictionaries.carTypesWithChildren, truckTypes);

  return (
    <MobileScreen hasBackButton actions={isDefault ? undefined : actions} title={i18n.carTypes.label}>
      <WrappedOptionsSelector
        classNames={{ desktopOptionList: css.list }}
        dictionary={data.carTypesStringified}
        matchMedia="1px"
        selectedValues={selectedValues}
        /* @ts-ignore */
        onChange={handleChange}
      />
    </MobileScreen>
  );
};

const connected = observer(Mobile);

export { connected as Mobile };
